var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"body-1",attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12","sm":"5"}},[_vm._v(" Frete ")]),_c('v-col',{staticClass:"text-right font-weight-bold",attrs:{"cols":"12","sm":"7"}},[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.item.frete))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }